export default {
  SaveFailTitle: 'Cất không thành công',
  InvalidYear: 'Không hợp lệ',
  NoFixedAsset:"Chưa chọn TSCĐ",
  PleaseChooseAsset: "Vui lòng chọn tài sản",
  Title: {
    FAVoucherIncreament: 'Ghi tăng TSCĐ từ MISA QLTS',
    FAVoucherDecrement: 'Ghi giảm TSCĐ từ MISA QLTS',
    FAVoucherDepreciation: 'Tính hao mòn TSCĐ từ MISA QLTS',
    FAVoucherAdjustment: 'Điều chỉnh TSCĐ từ MISA QLTS',
    ApplyYear: "Năm bắt đầu áp dụng: "
  },
  LeftInfo: {
    Target: 'Đối tượng',
    Name: 'Họ tên',
    Address: 'Địa chỉ',
    Description: 'Diễn giải',
    Account: 'TKKB',
    AccountBankTitle: 'Tài khoản kho bạc',
  },
  RightInfo: {
    VoucherDate: 'Ngày CT',
    RefDate: 'Ngày HT',
    VoucherNumber: 'Số CT',
    VoucherDateTitle: 'Ngày chứng từ',
    RefDateTitle: 'Ngày hạch toán',
    VoucherNumberTitle: 'Số chứng từ',
  },
  Button: {
    Close: 'Đóng',
    CloseTooltip: 'Đóng (ESC)',
  },
};
